import { useMemo } from 'react';
import { mixed, object, string } from 'yup';
import validator from 'card-validator';
import { ICreditCardFormData } from '../ICreditCardFormData';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import {
	CreditCardType,
	ICreditCardExpiryDate,
} from '../../../../domain/models';

export function useCreditCardSchema() {
	const { t } = useTranslation();

	return useMemo(
		() =>
			object<ICreditCardFormData>({
				creditCardType: mixed()
					.oneOf(Object.values(CreditCardType))
					.required(t('credit_card_type_form_field_error')),
				expiryDate: object()
					.shape({
						month: string().required(
							t('payment_form_expiry_date_pattern_error'),
						),
						year: string().required(
							t('payment_form_expiry_date_pattern_error'),
						),
					})
					.required(t('credit_card_expiry_date_form_field_error'))
					.transform(transformExpiryDate),
			}).required(),
		[t],
	);
}

function transformExpiryDate(
	_value: ICreditCardExpiryDate | null,
	original: ICreditCardExpiryDate | string,
) {
	const { isValid, month, year } = validator.expirationDate(original);

	if (!isValid) {
		return undefined;
	}

	return { month, year };
}
